<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/4 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col sm:w-full md:w-full d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mt-4 mb-8 flex justify-center">
                  <!-- <h4 class="mb-4">Login</h4>
                  <p>Welcome back, please login to your account.</p> -->
                  <img
                    style="width: 200px"
                    src="@/assets/images/logo/login-logo.png"
                  />
                </div>

                <form action="" method="post" @submit.prevent="submitLogin()">
                  <vs-input
                    name="username"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Username"
                    v-model="username"
                    class="w-full"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errorMessage != ''"
                    >{{ errorMessage }}</span
                  >

                  <vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    v-model="password"
                    class="w-full mt-6"
                  />

                  <!-- <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3"
                      >Remember Me</vs-checkbox
                    >
                    <router-link to="">Forgot Password?</router-link>
                  </div> -->
                  <div class="flex justify-center">
                    <vs-button
                      button="submit"
                      class="mt-5"
                      style="width: auto"
                      @click.prevent="submitLogin()"
                      >Login</vs-button
                    >
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      username: "",
      password: "",
      checkbox_remember_me: false,
      errorMessage: "",
    };
  },
  methods: {
    submitLogin() {
      this.errorMessage = "";
      this.$vs.loading();
      api
        .postLogin({
          username: this.username,
          password: this.password,
        })
        .then((result) => result.data)
        .then((data) => {
          if (!data.status) {
            this.errorMessage = data.message;
          } else {
            console.log(data);
            //set token to local storage
            localStorage.setItem("accessToken", data.data[0]);
            location.href = "/";
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.loading.close();
        });
    },
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
